const EduEspCode = {
  ParentRelationType: 1,
  StudentStatus: 2,
  LocationTypes: 3,
  UserLocationTypes: 4,
  InstitutionServiceCode: 5,
  MediaKnowAboutSpecialEducation: 6,
  SeverityType: 7,
  AutismType: 8,
  FrmCategory: 10,
  CatlibSubject: 11,
  CatlibReadingmedium: 12,
  AsistantType: 13,
  ResourceType: 14,
  DailyShift: 15,
  AuxiliaryType: 16,
  GraduatedWithHighSchoolDiploma: 106,
  ReachedMaximumAge: 108,
  ReceivedModifiedCertificationOrDiploma: 109
};

export default EduEspCode;
